/**
* Copyright by:

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { RecordBaseModel, WorkflowItemSubtype, WorkflowItemType } from '../record-base.model';
import { InfoRecord } from './info-record.model';
import { CameraRecord } from './camera-record.model';
import { QuestionRecord } from './question-record.model';
import { UnknownRecord } from './unknown-record.model';
import { InputRecord } from './input-record.model';
import { ChecklistRecord } from './checklist-record.model';
import { SignatureRecord } from './signature-record.model';
import { ScannerRecord } from './scanner-record.model';
import { faSquareFull, IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { FormRecord } from './form-record.model';

export class RecordModel implements RecordBaseModel {
  itemName: string;
  itemType: WorkflowItemType;
  itemSubtype?: WorkflowItemSubtype;
  itemTitle: string;
  itemData?: any;
  itemIcon: IconDefinition = faSquareFull;

  constructor(itemName: string, itemType: WorkflowItemType, itemSubtype?: WorkflowItemSubtype) {
    this.itemName = itemName;
    this.itemType = itemType;
    this.itemTitle = itemName;
    if (itemSubtype) this.itemSubtype = itemSubtype;
  }

  fromJson(json: any): RecordBaseModel | undefined {
    if (!json || !json.itemName) return;
    switch (json.itemType.value) {
      case WorkflowItemType.QUESTION:
        let questionRecord = Object.create(QuestionRecord.prototype);
        return questionRecord.fromJson(json);

      case WorkflowItemType.CAMERA:
        let cameraRecord = Object.create(CameraRecord.prototype);
        return cameraRecord.fromJson(json);

      case WorkflowItemType.SIGNATURE:
        let signatureRecord = Object.create(SignatureRecord.prototype);
        return signatureRecord.fromJson(json);

      case WorkflowItemType.SCANNER:
        let scannerRecord = Object.create(ScannerRecord.prototype);
        return scannerRecord.fromJson(json);

      case WorkflowItemType.FORM:
        switch (json.itemSubtype?.value) {
          case WorkflowItemSubtype.INFO:
            let infoRecord = Object.create(InfoRecord.prototype);
            return infoRecord.fromJson(json);

          case WorkflowItemSubtype.INPUT:
            let inputRecord = Object.create(InputRecord.prototype);
            return inputRecord.fromJson(json);

          case WorkflowItemSubtype.CHECKLIST:
            let checklistRecord = Object.create(ChecklistRecord.prototype);
            return checklistRecord.fromJson(json);

          default:
            let formRecord = Object.create(FormRecord.prototype);
            return formRecord.fromJson(json);
        }

      default:
        let unknownRecord = Object.create(UnknownRecord.prototype);
        return unknownRecord.fromJson(json);
    }
  }
}
